import React, { Component } from 'react';
import styled from 'styled-components';
import { Formik } from 'formik';
import {
  Input,
  Label,
  Row,
  UserWarn,
  Text,
  Button,
  Title,
} from '../../../theme/index';
import { connect } from 'react-redux';
import { changePassword, CHANGE_PASSWORD_SUCCESS } from '../redux/actions';

const Wrapper = styled.div``;

const Form = styled.form`
  width: 400px;
  height: 200px;
`;

class ChangePasswordForm extends Component {
  state = {
    message: '',
  };
  render() {
    const { message } = this.state;
    return (
      <Wrapper>
        <Title>Change password</Title>
        <Formik
          initialValues={{
            newPassword: '',
            confirmPassword: '',
            currentPassword: '',
          }}
          validate={values => {
            let errors = {};
            if (values.newPassword && values.confirmPassword) {
              if (values.newPassword !== values.confirmPassword) {
                errors.password = 'Passwords do not match';
              }
            }
            return errors;
          }}
          onSubmit={values => {
            let data = {
              current_password: values.currentPassword,
              new_password: values.newPassword,
            };
            this.props.changePassword(data).then(action => {
              if (action.type === CHANGE_PASSWORD_SUCCESS) {
                this.setState({ message: 'Password successfully updated' });
              } else {
                this.setState({
                  message: 'There was an error, please try again',
                });
              }
            });
          }}
          render={({
            handleChange,
            values,
            touched,
            errors,
            handleBlur,
            handleSubmit,
          }) => (
            <Form onSubmit={handleSubmit}>
              {message && <Text style={{ color: '#FFAF77' }}>{message}</Text>}
              <Row
                alignitems="center"
                style={{ position: 'relative', zIndex: 1000 }}
              >
                <Label htmlFor="currentPassword">
                  Current Password *
                  {touched.currentPassword && errors.currentPassword && (
                    <UserWarn>
                      <Text error>{errors.currentPassword}</Text>
                    </UserWarn>
                  )}
                  <Input
                    type="password"
                    id="currentPassword"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.currentPassword}
                    login
                  />
                </Label>
              </Row>
              <Row
                alignitems="center"
                style={{ position: 'relative', zIndex: 1000 }}
              >
                <Label htmlFor="newPassword">
                  New Password *
                  {touched.newPassword && errors.newPassword && (
                    <UserWarn>
                      <Text error>{errors.newPassword}</Text>
                    </UserWarn>
                  )}
                  <Input
                    type="password"
                    id="newPassword"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.newPassword}
                    login
                  />
                </Label>
              </Row>
              <Row
                alignitems="center"
                style={{ position: 'relative', zIndex: 1000 }}
              >
                <Label htmlFor="confirmPassword">
                  Confirm Password *
                  {touched.confirmPassword && errors.confirmPassword && (
                    <UserWarn>
                      <Text error>{errors.confirmPassword}</Text>
                    </UserWarn>
                  )}
                  <Input
                    type="password"
                    id="confirmPassword"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.confirmPassword}
                    login
                  />
                </Label>
              </Row>

              <Button home type="submit">
                Save
              </Button>
            </Form>
          )}
        />
      </Wrapper>
    );
  }
}

export default connect(
  null,
  { changePassword }
)(ChangePasswordForm);



// WEBPACK FOOTER //
// ./src/components/screens/ChangePassword/components/ChangePasswordForm.jsx